import {
  flightOffersComparator,
  getFilteredFlightOffers,
} from "shared/containers/Filters/helpers";
import { SearchQuery } from "shared/data/reducers/types";
import { getAverageFlightLength } from "shared/lib/functions";
import FlightOffer from "shared/types/flightOffer";

enum FlightType {
  minimalPriceFlight,
  minimalLengthFlight,
  minimalDurationOpportunityCostPriceFlight,
}

type FlightObject = {
  flight: FlightOffer;
  type: FlightType;
};

export const prepareFlightSortingDetails = (
  flightOffers: FlightOffer[],
  query: SearchQuery
) => {
  const filteredFlightOffers = getFilteredFlightOffers(flightOffers, query);
  if (!filteredFlightOffers || filteredFlightOffers.length === 0) {
    return null;
  }

  const minimalPriceFlight = filteredFlightOffers.reduce((prev, curr) =>
    flightOffersComparator(prev, curr, "PRICE") !== 1 ? prev : curr
  );
  const minimalLengthFlight = filteredFlightOffers.reduce((prev, curr) =>
    flightOffersComparator(prev, curr, "FLIGHT_LENGTH") !== 1 ? prev : curr
  );
  const minimalDurationOpportunityCostPriceFlight = filteredFlightOffers.reduce(
    (prev, curr) =>
      flightOffersComparator(prev, curr, "DURATION_OPPORTUNITY_COST_PRICE") !==
      1
        ? prev
        : curr
  );

  const getFlightPrice = (flight: FlightOffer) =>
    flight.FlightCombinations[0].PricingDetail.FlightPricing.FlightPrice;

  const getAlternativeCurrencyFlightPrice = (flight: FlightOffer) =>
    flight.FlightCombinations[0].AlternativeCurrencyPricingDetail.FlightPricing
      .FlightPrice;

  const createFlightObject = (flightObject: FlightObject) => {
    const isAlternativeCurrency =
      flightObject.flight.FlightCombinations[0]
        .AlternativeCurrencyPricingDetail;
    const alternativeCurrencyPriceOption = isAlternativeCurrency
      ? {
          alternativeCurrencyPrice: getAlternativeCurrencyFlightPrice(
            flightObject.flight
          ).FullPrice,
        }
      : {};
    return {
      [FlightType[flightObject.type]]: {
        price: getFlightPrice(flightObject.flight).FullPrice,
        ...alternativeCurrencyPriceOption,
        length: getAverageFlightLength(flightObject.flight),
      },
    };
  };

  const minimalDurationOpportunityCostPriceFlightOptionalObject =
    getFlightPrice(minimalDurationOpportunityCostPriceFlight)
      .DurationOpportunityCostPrice >
    getFlightPrice(minimalDurationOpportunityCostPriceFlight).FullPrice
      ? createFlightObject({
          flight: minimalDurationOpportunityCostPriceFlight,
          type: FlightType.minimalDurationOpportunityCostPriceFlight,
        })
      : {};
  return {
    ...createFlightObject({
      flight: minimalPriceFlight,
      type: FlightType.minimalPriceFlight,
    }),
    ...createFlightObject({
      flight: minimalLengthFlight,
      type: FlightType.minimalLengthFlight,
    }),
    ...minimalDurationOpportunityCostPriceFlightOptionalObject,
  };
};
